// SignOut.tsx
import { useEffect } from "react";
import { getSsoClient } from "../../helpers/get-sso-client";

export const SignOutForwarder = () => {
  const ssoClient = getSsoClient();
  useEffect(() => {
    ssoClient.actions.signOut(window.location.origin);
  }, [ssoClient]);

  return null;
};
